import React, {useState, useEffect, useContext} from 'react';
import {PageCover, BoardHeader, BoardBody, Footer, WriteQna} from 'components/section';
import {Loading} from 'components/items';
// firebase
import firebase from 'library/firebase-config.js';
import 'firebase/storage';
import { authContext } from '../shared/App';
const db = firebase.firestore();

const coverData = [
  {
    gnb: "customer",
    title: "CUSTOMER CENTER",
    text: "동구밭을 사랑해주는 분들과 함께 만들어 가기 위해 목소리에 귀를 기울입니다"
  },{
    gnb: "recruit",
    title: "RECRUIT",
    text: "발달장애인과 비장애인이 함께 어우러져 일하는 직장, 동구밭을 만들어 갈 멤버를 찾습니다."
  }
]
const titleData = [{
    id: 1,
    lnb: "staff",
    gnb: "recruit",
    title: ["가꿈지기 ", "채용 공고"],
    text: ``,
    btnName: '발달장애인 사원 지원서 양식'
  },{
    id: 2,
    lnb: "manager",
    gnb: "recruit",
    title: ["직원 ", "채용 공고"],
    text: ``,
    btnName: '비장애인 사원 지원서 양식'
  } ,{
    id: 3,
    lnb: "notice",
    gnb: "customer",
    title: ["공지사항"],
    text: "동구밭 관련 소식들을 전해드립니다.",
    btnName: ''
  } ,{
    id: 4,
    lnb: "qna",
    gnb: "customer",
    title: ["Q & A"],
    text: "동구밭 팩토리에 궁금한 점을 문의해주세요.",
    btnName: ''
  }
]


const Board = (props) => {

  const [nowCoverData, setNowCoverData] = useState({});
  const [nowTitleData, setNowTitleData] = useState({});
  const [writeQna, setWriteQna] = useState(false);
  const [COLLECTION, setCOLLECTION] = useState('');
  const [data, setData] = useState([]);
  const {setIsBoardLoading} = useContext(authContext);
  const [isLoading, setIsLoading] = useState(false);


  useEffect(()=> {
    coverData.forEach(el=> {
      if(el.gnb===props.gnb){
        setNowCoverData(el);
      }
    })
  },[props.gnb]);


  useEffect(()=> {
    titleData.forEach(el=> {
      if(el.lnb === props.lnb){
        setNowTitleData(el);
      }
    })
  },[props.lnb])

  useEffect(()=> {
    setCOLLECTION(`${props.gnb}_${props.lnb}`);
  }, [props.gnb, props.lnb])

  useEffect(()=> {
    if(COLLECTION){
      const _get = async () => {
        setIsBoardLoading(true);
        const getData = await db.collection(COLLECTION).orderBy("timestamp", 'desc').get();
        const dum = [];
        getData.docs.forEach(doc => {
          dum.push({
            ...doc.data(), 
            id: doc.id,
          });
        })
        setData(dum);
        setIsBoardLoading(false);
      }
      _get();
    }
  } , [COLLECTION, setIsBoardLoading])

  const handleWirteClicked = () => {
    setWriteQna(true);
  }

  return (
    <div className="Board padding-cover">
      <PageCover 
        url={props.gnb}
        title = {nowCoverData.title}
        text = {nowCoverData.text}
      />

      <BoardHeader data = {nowTitleData}/>
      <BoardBody lnb = {props.lnb} gnb = {props.gnb} onClick = {handleWirteClicked} data = {data}/>

      <div className={`dim ${writeQna ? `active` : ""}`}></div>
      <WriteQna writeQna = {writeQna} setWriteQna = {setWriteQna} setData = {setData} data = {data} setIsLoading = {setIsLoading}/>
      <Footer />

      <Loading className={`${isLoading ? '': 'hide'}`}/>
    </div>
  );
}

export default Board;